import React from "react";
import { Stack, Typography, Button } from "@mui/material";
import TextInput from "../inputs/TextField";
import { useFormik } from "formik";
import * as Yup from "yup";
import Select from "../inputs/Select";
import countryCodes from "./helpers/countryData";

export interface RecoverPasswordFormInterface {
  initialData: { phone: ""; code: "" };
  handleAction: (type: string, data: any) => void;
}
const SCHEMA = {
  code: Yup.string().required("Please select country code"),
  phone: Yup.string().required("Please enter phone number"),
};
const RecoverPasswordForm = ({
  initialData,
  handleAction,
}: RecoverPasswordFormInterface) => {
  const { values, handleChange, handleBlur, handleSubmit, touched, errors } =
    useFormik({
      initialValues: initialData,
      validationSchema: Yup.object(SCHEMA),
      onSubmit: (value) => handleAction("submit", value),
    });
  return (
    <form onSubmit={handleSubmit} style={{ width: "100%", height: "100%" }}>
      <Stack
        alignItems="center"
        justifyContent="space-between"
        width="100%"
        height="100%"
      >
        <Typography variant="h1" fontWeight={700} textAlign="center">
          Add a phone number
          <br />
          for security
        </Typography>
        <Stack direction="row" width="100%" alignItems="center" spacing={2}>
          <Select
            label="Country Code"
            options={countryCodes.map((option) => ({
              value: option.code,
              label: `${option.code} | ${option.country}`,
            }))}
            name="code"
            id="code"
            placeholder="Select Code"
            helperText={touched.code ? errors.code : ""}
            error={touched.code && Boolean(errors.code)}
            value={values.code}
            onChange={handleChange}
            onBlur={handleBlur}
            minWidth="120px"
          />

          <TextInput
            label="Phone number"
            name="phone"
            id="phone"
            placeholder="phone"
            helperText={touched.phone ? errors.phone : ""}
            error={touched.phone && Boolean(errors.phone)}
            value={values.phone}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        </Stack>
        <Stack
          spacing={5}
          width="100%"
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Button
            variant="text"
            sx={{ color: "#000", width: "fit-content" }}
            fullWidth
            onSubmit={() => handleSubmit()}
          >
            Skip
          </Button>
          <Button
            variant="contained"
            color="primary"
            onSubmit={() => handleSubmit()}
          >
            Send Code
          </Button>
        </Stack>
      </Stack>
    </form>
  );
};
export default RecoverPasswordForm;
